export default {
  isModalShow: state => state.isModalShow,
  getMessage: state => state.message
}